export const timedMarkerData = [
  {
    iconUrl: './assets/cars/green.svg',
    text: '0-10min',
    backgroundColor: 'var(--success300)',
  },
  {
    iconUrl: './assets/cars/blue.svg',
    text: '10-60min',
    backgroundColor: 'var(--teal400)',
  },
  {
    iconUrl: './assets/cars/orange.svg',
    text: '1-24h',
    backgroundColor: 'var(--orange400)',
  },
  {
    iconUrl: './assets/cars/red.svg',
    text: '24-48h',
    backgroundColor: 'var(--error500)',
  },
  {
    iconUrl: './assets/cars/black.svg',
    text: '48h',
    backgroundColor: 'var(--blueGrey400)',
  },
];

export const timedMaintainerData = [
  {
    iconUrl: './assets/cars/maintainer_active.svg',
    text: '0-15min',
  },
  {
    iconUrl: './assets/cars/maintainer_standby.svg',
    text: '15-60min',
  },
  {
    iconUrl: './assets/cars/maintainer_sleep.svg',
    text: '1h',
  },
];

export enum LocationOnCallStatusIcon {
  ONCALL = './assets/locations/active.svg',
  IDLE = './assets/locations/idle.svg',
  NOTONCALL = './assets/locations/off.svg',
}
